<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card :loading="loading">
            <v-card-title>
                <h1 class="text-h5">
                    Zatwierdzanie czynności dodatkowej
                </h1>
            </v-card-title>

            <v-divider />
            <div class="text-center mt-6">
                <p class="text-h6 font-weight-light">
                    {{ parseEmptyValue(reportData.userName) }}
                </p>

                <h2 class="text-h6">
                    Nazwa czynności:
                </h2>
                <p class="text-h6 font-weight-light">
                    {{ parseEmptyValue(reportData.processName) }}
                </p>
                <div class="mx-5 my-1">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="message"
                                outlined
                                dense
                                no-resize
                                label="Komentarz"
                                :error-messages="messageErrors"
                                @input="() => messageErrors = []"
                            />
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-divider />

            <v-card-actions
                class="d-flex justify-space-between w-full"
            >
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="loading"
                    @click="rejectAdditionalActivities()"
                >
                    Odrzuć
                </v-btn>
                <v-btn
                    text
                    data-sentry-label="Zamknij"
                    :disabled="loading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="loading"
                    @click="approveAdditionalActivities()"
                >
                    <template>
                        Zapisz
                    </template>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import parse from '@/mixins/parse'
import { errorHandler } from '@/utils/errorHandler'

// Constants for additional activities status
const STATUS = {
    APPROVED: 20,
    REJECTED: 30,
}

export default {
    name: 'ApprovalAdditionalActivitiesDialog',
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        isShipment: {
            type: Boolean,
            default: false
        },
        reportId: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            message: '',
            messageErrors: [],
            reportData: {},
            loading: false,
        }
    },
    watch: {
        isOpen(value) {
            if (value && this.reportId) {
                this.loading = true
                this.$store.dispatch('reports/getReport', this.reportId)
                    .then(response => {
                        this.reportData = response
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    },
    methods: {
        approveAdditionalActivities() {
            this.messageErrors = []
            if (this.message.length > 128 || (this.message.length > 0 && this.message.length < 3)) {
                this.messageErrors.push('Proszę podać komentarz o długości od 3 do 128 znaków, lub zostawić pustym.')

                return
            }

            this.sendAdditionalActivities(STATUS.APPROVED)
        },
        rejectAdditionalActivities() {
            this.messageErrors = []
            if (this.message.length < 3 || this.message.length > 128) {
                this.messageErrors.push('Proszę podać komentarz o długości od 3 do 128 znaków.')

                return
            }

            this.sendAdditionalActivities(STATUS.REJECTED)
        },
        sendAdditionalActivities(status) {
            this.loading = true
            const action = this.isShipment
                ? 'shipments/sendings/reviewAdditionalShipmentAction'
                : 'reports/reviewAdditionalAction'

            this.$store.dispatch(action, {
                reportId: this.reportId,
                reportProcessCodeStatusId: status,
                reportProcessCodeDescription: this.message ?? '',
            })
                .then(() => {
                    this.$store.dispatch('showNotification', {
                        type: 'success',
                        message: 'Czynności dodatkowe zostały zatwierdzone.',
                    })
                    this.onCloseWithSuccess()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onCloseWithSuccess() {
            this.$emit('on-success')
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.reportData = {}
                this.messageErrors = []
                this.message = ''
            }, 500)
        },
    }
}
</script>
